export default "__VITE_ASSET__B07DNZXJ__"